/*
export const someGetter = (state) => {}
 */
import { date } from 'quasar'
import { lk } from 'src/utils'

export default {
  approvalList,
  classApprovalStatuses
}

function approvalList (state, getters, rootState) {
  return state.list
}

function classApprovalStatuses(state){
  return _.map(lk.LK_CLASS_APPROVAL_STATUS_ID,(s,key)=>{
    return {
      label: _.capitalize(key),
      value: s
    }
  })
}
